export default __webpack_public_path__ + "media/images/mailer/icon_done-f4488226df05e7ecb32507ee4dfe203b.png";